import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot, Router } from '@angular/router';
import { Observable, EMPTY } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { BlogService, BlogPost } from './blog.service';

@Injectable({
  providedIn: 'root'
})
export class BlogResolver implements Resolve<BlogPost> {
  constructor(
    private blogService: BlogService,
    private router: Router
  ) {}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<BlogPost> {
    const slug = route.paramMap.get('slug');
    if (!slug) {
      this.router.navigate(['/blog']);
      return EMPTY;
    }
    
    return this.blogService.getBlogByUrl(slug).pipe(
      catchError(error => {
        console.error('Error fetching blog post:', error);
        this.router.navigate(['/blog']);
        return EMPTY;
      })
    );
  }
} 